App.factory('pzuwInsurerService', ['baseService', 'Config', function (baseService, Config) {
    function PzuwInsurerService() {

        this.getReports = function (criteria) {
            return baseService.get(`${Config.API_URL}/insurer/healthInsurance/pzuw/report`, criteria)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.downloadReport = function (id, rehabilitation) {
            return baseService.download(`${Config.API_URL}/insurer/healthInsurance/pzuw/report/${id}/excel?rehabilitation=${rehabilitation}`)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };
    }

    return new PzuwInsurerService();
}]);
